import {SActionBtn, SLowcodeList, STableActions} from "shj-components";
import {config} from "./config.tsx";
import {openEdit} from "./edit.tsx";
import {tableApiFunc} from "@/utils/data.ts";
import {delChannelRoleRef,getMemberChannelRolePage, getRoleListFn} from "@/services/member.ts";
import {message} from "antd";
import {useRef } from "react";
import {getChannels} from "@/services/getUsers.ts";
import {isArray} from "lodash-es";

/**
 *
 * 报名渠道配置
 * @constructor
 */
function Page() {
    const tableRef = useRef<any>();
    const onDelete = (id: string) => {
        delChannelRoleRef({id}).then(() => {
            message.success('删除成功');
            tableRef.current.reload();
        })
    }
    const onAddOrEdit = (type:string,data?: any) => {
        openEdit({
            title: `${type==='add'?'新增':'编辑'}报名渠道配置`,
            data,
            destroy: (success) => {
                if (success) {
                    tableRef.current.reload();
                }
            }
        });
    }
    const getSelection = async () => {
        const channelTree = await getChannels();
        const roleList = await getRoleListFn({ data: { enabled: true } })
        return Promise.resolve({
            channelTree,
            roleList
        })
    }
    const extensions = {
        request: {
            fetchList: tableApiFunc(getMemberChannelRolePage, {
                paginationInBody: true,
                data: {queryName: true},
                fieldNames: {current: 'current'},
                transformSearch: (data) => {
                    const {channelIds,...rest} = data || {};
                    const channelId = isArray(channelIds)&&channelIds?.length>0?channelIds[channelIds?.length-1]:'';
                    return {
                        ...rest,
                        channelId
                    };
                }
            }),
            getSelection,
        },
        events: {onAdd: () => onAddOrEdit('add',{})},
        customRender: {
            roleRender(_: null, record: Record<string, any>) {
                const {roleNames} = record;
                if (isArray(roleNames)&&roleNames?.length>0) {
                    return roleNames?.map((item: any) => item).join('、')
                }
                return roleNames || "";
            },
            actionRender(_: null, record: Record<string, any>) {
                return (
                    <STableActions>
                        <SActionBtn onClick={() => onAddOrEdit('edit',record)}>编辑</SActionBtn>
                        {!record.status && <SActionBtn isDelete onClick={() => onDelete(record.id)}>删除</SActionBtn>}
                    </STableActions>
                )
            }
        }
    }
    return (
        <div>
            <div style={{display: 'flex'}}>
                <SLowcodeList
                    searchMode={'group'}
                    config={config}
                    ref={tableRef}
                    {...extensions}
                />
            </div>
        </div>
    );
}

export default Page;
